import { useQuery } from '@tanstack/react-query'
import { employeeOrderApi } from '@/api/employee'
import type { EmployeeOrderListParams } from '@/types/employee'

export const employeeOrderKeys = {
  all: ['employee', 'orders'] as const,
  lists: () => [...employeeOrderKeys.all, 'list'] as const,
  list: (params: EmployeeOrderListParams) => [...employeeOrderKeys.lists(), params] as const,
  details: () => [...employeeOrderKeys.all, 'detail'] as const,
  detail: (id: number) => [...employeeOrderKeys.details(), id] as const,
}

export function useEmployeeOrders(params: EmployeeOrderListParams) {
  return useQuery({
    queryKey: employeeOrderKeys.list(params),
    queryFn: () => employeeOrderApi.list(params),
    placeholderData: (previousData) => previousData,
  })
}

export function useEmployeeOrderDetail(id: number, enabled = true) {
  return useQuery({
    queryKey: employeeOrderKeys.detail(id),
    queryFn: () => employeeOrderApi.detail(id),
    enabled: enabled && id > 0,
  })
}
